import { extendObservable, computed } from "mobx";
import Autobind from "autobind-decorator";

@Autobind
class SarcopeniaMeasureModel {
  constructor(data: { [string: string]: string }) {
    extendObservable(this, data);
  }
}

export default SarcopeniaMeasureModel;
